import { useEffect } from 'react'
import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'
import { useAuthStore } from '@/stores/authStore'

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    person_profiles: 'always',
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-mask]',
    },
  })
}

function PostHogIdentify() {
  const { user, isAuthenticated } = useAuthStore()

  useEffect(() => {
    if (!posthogKey) return
    if (isAuthenticated && user) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.name,
        role: user.role,
        vendor_id: user.vendorId,
        subscription_tier: user.subscriptionTier,
      })
      if (user.vendorId) {
        posthog.group('vendor', user.vendorId)
      }
    }
  }, [isAuthenticated, user?.id])

  return null
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!posthogKey) return <>{children}</>

  return (
    <PHProvider client={posthog}>
      <PostHogIdentify />
      {children}
    </PHProvider>
  )
}
